import { Outlet } from "react-router-dom";
import Header from "./Header";
import Navigation from "./Navigation";

export default function UnifiedLayout() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Navigation>
        <Outlet />
      </Navigation>
    </div>
  );
}